import { httpGetAsync } from "../../utilities/TZMRequest";

export class IndiceService {
	
	listar = async () =>{
		return await httpGetAsync("/indices");
	}

}
